import PenaltyUploadRepositoryImpl from './impl/PenaltyUploadRepositoryImpl'

export default {
  getInstance () {
    return new PenaltyUploadRepositoryImpl()
  }
}
